import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createTextVNode as _createTextVNode, withModifiers as _withModifiers, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-f5bd6f1e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "fw-bold mb-4" }
const _hoisted_2 = { class: "d-flex justify-content-end" }
const _hoisted_3 = {
  href: "/files/【YELLoop】user_upload_format.csv",
  download: "",
  class: "button-router-link fw-bold text-decoration-none btn-down bg-white shadow d-flex align-items-center justify-content-center"
}
const _hoisted_4 = { class: "px-3 pt-5 pb-3 fs-7 text-center" }
const _hoisted_5 = { class: "form-csv p-3" }
const _hoisted_6 = { class: "rounded-4 d-flex align-items-center justify-content-center mb-2" }
const _hoisted_7 = { class: "mx-0 col-7 d-flex align-items-center" }
const _hoisted_8 = { class: "d-flex input-group" }
const _hoisted_9 = ["placeholder", "value"]
const _hoisted_10 = { class: "mb-3 d-none" }
const _hoisted_11 = ["placeholder"]
const _hoisted_12 = {
  key: 0,
  class: "fs-8 text-danger text-center"
}
const _hoisted_13 = {
  key: 1,
  class: "fs-8 text-danger text-center"
}
const _hoisted_14 = {
  key: 2,
  class: "fs-8 text-danger text-center"
}
const _hoisted_15 = {
  key: 3,
  class: "fs-8 text-danger text-center"
}
const _hoisted_16 = { class: "d-flex align-items-center justify-content-center px-3 py-2" }
const _hoisted_17 = { class: "col-7 fs-7" }
const _hoisted_18 = { key: 0 }
const _hoisted_19 = { class: "success p-3 rounded-1 mb-4" }
const _hoisted_20 = { class: "d-flex align-items-center mb-3" }
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "16",
  viewBox: "0 0 16 16"
}, [
  /*#__PURE__*/_createElementVNode("g", {
    id: "Group_2857",
    "data-name": "Group 2857",
    transform: "translate(-25 -18)"
  }, [
    /*#__PURE__*/_createElementVNode("rect", {
      id: "Rectangle_3339",
      "data-name": "Rectangle 3339",
      width: "16",
      height: "16",
      rx: "8",
      transform: "translate(25 18)",
      fill: "#00b140"
    }),
    /*#__PURE__*/_createElementVNode("path", {
      id: "check",
      d: "M12.512,5.022a.915.915,0,0,1,1.3-.013.926.926,0,0,1,.013,1.3L8.937,12.45a.915.915,0,0,1-1.322.025L4.377,9.221a.924.924,0,0,1,.4-1.569.915.915,0,0,1,.9.265l2.563,2.574,4.251-5.442a.289.289,0,0,1,.024-.027Z",
      transform: "translate(23.914 17.255)",
      fill: "#fff",
      "fill-rule": "evenodd"
    })
  ])
], -1))
const _hoisted_22 = { class: "ps-2 fw-bold" }
const _hoisted_23 = { class: "fs-7 mt-2" }
const _hoisted_24 = { class: "fw-bold mt-2" }
const _hoisted_25 = { key: 0 }
const _hoisted_26 = { class: "fs-7 mt-2" }
const _hoisted_27 = { class: "fs-7 mt-2 d-flex" }
const _hoisted_28 = { key: 1 }
const _hoisted_29 = { class: "error-success p-3 rounded-1 mb-4" }
const _hoisted_30 = { class: "d-flex align-items-center mb-3" }
const _hoisted_31 = /*#__PURE__*/_createStaticVNode("<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"18\" height=\"18\" viewBox=\"0 0 18 18\" data-v-f5bd6f1e><g id=\"Group_3189\" data-name=\"Group 3189\" transform=\"translate(-24 -16)\" data-v-f5bd6f1e><g id=\"Group_2856\" data-name=\"Group 2856\" transform=\"translate(-564 -409)\" data-v-f5bd6f1e><rect id=\"Rectangle_3355\" data-name=\"Rectangle 3355\" width=\"18\" height=\"18\" transform=\"translate(588 425)\" fill=\"none\" data-v-f5bd6f1e></rect><g id=\"Polygon_51\" data-name=\"Polygon 51\" transform=\"translate(588 427)\" fill=\"none\" stroke-linecap=\"round\" stroke-linejoin=\"round\" data-v-f5bd6f1e><path d=\"M8.143,1.429a1,1,0,0,1,1.715,0l7.234,12.056A1,1,0,0,1,16.234,15H1.766a1,1,0,0,1-.857-1.514Z\" stroke=\"none\" data-v-f5bd6f1e></path><path d=\"M 8.999845504760742 1.943916320800781 L 9 1.943657875061035 L 1.766189575195312 13.99999809265137 L 16.23381042480469 14.00000762939453 L 8.999845504760742 1.943916320800781 M 9 0.9436531066894531 C 9.331645011901855 0.9436531066894531 9.663290023803711 1.105487823486328 9.857489585876465 1.429158210754395 L 17.09130096435547 13.48550796508789 C 17.49122047424316 14.15202808380127 17.01110076904297 14.99999809265137 16.23381042480469 14.99999809265137 L 1.766189575195312 14.99999809265137 C 0.9888992309570312 14.99999809265137 0.5087795257568359 14.15202808380127 0.9087009429931641 13.48550796508789 L 8.142510414123535 1.429158210754395 C 8.336709976196289 1.105487823486328 8.668354988098145 0.9436531066894531 9 0.9436531066894531 Z\" stroke=\"none\" fill=\"#dc3545\" data-v-f5bd6f1e></path></g></g><path id=\"Path_3305\" data-name=\"Path 3305\" d=\"M2.322-6.966H.918l.216,5.031h.909ZM2.232-1.2H.954V.018H2.232Z\" transform=\"translate(31.38 31)\" fill=\"#dc3545\" stroke=\"rgba(0,0,0,0)\" stroke-width=\"1\" data-v-f5bd6f1e></path></g></svg>", 1)
const _hoisted_32 = { class: "ps-2 fw-bold" }
const _hoisted_33 = { class: "fs-7" }
const _hoisted_34 = { class: "fs-7 my-2" }
const _hoisted_35 = { class: "fw-bold mt-2" }
const _hoisted_36 = { key: 2 }
const _hoisted_37 = { class: "success p-3 rounded-1 mb-4" }
const _hoisted_38 = { class: "d-flex align-items-center mb-3" }
const _hoisted_39 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "16",
  viewBox: "0 0 16 16"
}, [
  /*#__PURE__*/_createElementVNode("g", {
    id: "Group_2857",
    "data-name": "Group 2857",
    transform: "translate(-25 -18)"
  }, [
    /*#__PURE__*/_createElementVNode("rect", {
      id: "Rectangle_3339",
      "data-name": "Rectangle 3339",
      width: "16",
      height: "16",
      rx: "8",
      transform: "translate(25 18)",
      fill: "#00b140"
    }),
    /*#__PURE__*/_createElementVNode("path", {
      id: "check",
      d: "M12.512,5.022a.915.915,0,0,1,1.3-.013.926.926,0,0,1,.013,1.3L8.937,12.45a.915.915,0,0,1-1.322.025L4.377,9.221a.924.924,0,0,1,.4-1.569.915.915,0,0,1,.9.265l2.563,2.574,4.251-5.442a.289.289,0,0,1,.024-.027Z",
      transform: "translate(23.914 17.255)",
      fill: "#fff",
      "fill-rule": "evenodd"
    })
  ])
], -1))
const _hoisted_40 = { class: "ps-2 fw-bold" }
const _hoisted_41 = { class: "fs-7 mt-2" }
const _hoisted_42 = {
  key: 0,
  class: "mt-2"
}
const _hoisted_43 = { class: "fs-7 mt-2 d-flex" }
const _hoisted_44 = { class: "fw-bold mt-2" }
const _hoisted_45 = { key: 3 }
const _hoisted_46 = { class: "error-success p-3 rounded-1 mb-4" }
const _hoisted_47 = { class: "d-flex align-items-center mb-3" }
const _hoisted_48 = /*#__PURE__*/_createStaticVNode("<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"18\" height=\"18\" viewBox=\"0 0 18 18\" data-v-f5bd6f1e><g id=\"Group_3189\" data-name=\"Group 3189\" transform=\"translate(-24 -16)\" data-v-f5bd6f1e><g id=\"Group_2856\" data-name=\"Group 2856\" transform=\"translate(-564 -409)\" data-v-f5bd6f1e><rect id=\"Rectangle_3355\" data-name=\"Rectangle 3355\" width=\"18\" height=\"18\" transform=\"translate(588 425)\" fill=\"none\" data-v-f5bd6f1e></rect><g id=\"Polygon_51\" data-name=\"Polygon 51\" transform=\"translate(588 427)\" fill=\"none\" stroke-linecap=\"round\" stroke-linejoin=\"round\" data-v-f5bd6f1e><path d=\"M8.143,1.429a1,1,0,0,1,1.715,0l7.234,12.056A1,1,0,0,1,16.234,15H1.766a1,1,0,0,1-.857-1.514Z\" stroke=\"none\" data-v-f5bd6f1e></path><path d=\"M 8.999845504760742 1.943916320800781 L 9 1.943657875061035 L 1.766189575195312 13.99999809265137 L 16.23381042480469 14.00000762939453 L 8.999845504760742 1.943916320800781 M 9 0.9436531066894531 C 9.331645011901855 0.9436531066894531 9.663290023803711 1.105487823486328 9.857489585876465 1.429158210754395 L 17.09130096435547 13.48550796508789 C 17.49122047424316 14.15202808380127 17.01110076904297 14.99999809265137 16.23381042480469 14.99999809265137 L 1.766189575195312 14.99999809265137 C 0.9888992309570312 14.99999809265137 0.5087795257568359 14.15202808380127 0.9087009429931641 13.48550796508789 L 8.142510414123535 1.429158210754395 C 8.336709976196289 1.105487823486328 8.668354988098145 0.9436531066894531 9 0.9436531066894531 Z\" stroke=\"none\" fill=\"#dc3545\" data-v-f5bd6f1e></path></g></g><path id=\"Path_3305\" data-name=\"Path 3305\" d=\"M2.322-6.966H.918l.216,5.031h.909ZM2.232-1.2H.954V.018H2.232Z\" transform=\"translate(31.38 31)\" fill=\"#dc3545\" stroke=\"rgba(0,0,0,0)\" stroke-width=\"1\" data-v-f5bd6f1e></path></g></svg>", 1)
const _hoisted_49 = { class: "ps-2 fw-bold" }
const _hoisted_50 = { class: "fs-7" }
const _hoisted_51 = { class: "fs-7 mt-2 d-flex" }
const _hoisted_52 = { class: "fw-bold mt-2" }
const _hoisted_53 = {
  key: 4,
  class: "d-flex justify-content-center"
}
const _hoisted_54 = {
  key: 5,
  class: "d-flex justify-content-center"
}

import useVuelidate from '@vuelidate/core'
import { MAX_UPLOAD_FILE_SIZE_BYTES, MAX_UPLOAD_FILE_SIZE_MB } from '@/constants/number'
import { useRoute, useRouter } from 'vue-router'
import Button from '@/components/button/index.vue'
import { translate } from '@/languages/i18n'
import { computed, ref, watchEffect } from 'vue'
import communityManagerServices from '@/services/community-managers.services'
import Breadcrumb from '@/components/breadcrumb/index.vue'

// import { useToast } from 'vue-toastification'

// const toast = useToast()


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const route = useRoute()
const router = useRouter()
const inputRef = ref(null)
const fileName = ref('')
const fileType = ref(null)
const fileData = ref(null)
const ClickSubmit = ref<boolean>(false)
const data = ref({})
const hiddenSubmit = ref<boolean>(false)
const loading = ref<boolean>(false)
const disableBtn = ref<boolean>(false)
const checkExist = ref<boolean>(true)
const errorMaxUpload = ref<boolean>(false)
// 2022/09/15 TienNV fix bug uat#4114 OE80
const errorFileFormatUpload = ref<boolean>(false)
const error404 = ref<boolean>(false)
const dataUploadDub = ref()
const OE12_PATH = `/community/communities/${route.params?.id}/community-users?management_no=desc`

watchEffect(() => {
  disableBtn.value = !fileName.value
})

const formData = ref({
  file: null,
})

const rules = computed(() => {
  return {
    file: {
      fileSizeValidation: function (value) {
        if (value) {
          return value.size <= MAX_UPLOAD_FILE_SIZE_BYTES
        }
        return true
      },
    },
  }
})

const v$ = useVuelidate(rules, formData)

const breadcrumb = [
  {
    content: translate('CC10home'),
    to: `/community/communities/${route.params?.id}/dashboard`,
    active: false,
  },
  {
    content: translate('OE30userManagement'),
    to: '',
    active: false,
  },
  {
    content: translate('OE80userList'),
    to: OE12_PATH,
    active: false,
  },
  {
    content: translate('OE80uploaded'),
    to: '',
    active: true,
  },
]

const handleChangeFile = () => {
  fileName.value = inputRef.value?.files[0]?.name
  fileData.value = inputRef.value.files[0]
  fileType.value = inputRef.value.files[0].type
  hiddenSubmit.value = false
  data.value = {}
  if (inputRef.value?.files[0]) {
    v$.value.file.$model = inputRef.value?.files[0]
  }
}

const handleClick = () => {
  inputRef.value.click()
}
const ClearChoose = () => {
  fileName.value = ''
  fileType.value = null
  fileData.value = null
  v$.value.file.$model = null
}

const SubmitCSV = async (): void => {
  v$.value.$touch()
  if (v$.value.$invalid) return
  ClickSubmit.value = true
  const formData = new FormData()
  formData.append('file', fileData.value)
  if (fileData.value && ['application/vnd.ms-excel', 'text/csv'].includes(fileType.value)) {
    loading.value = true

    try {
      const response = await communityManagerServices.generalUserUpload(route?.params?.id, formData)
      if (!response?.data && !response?.response) {
        checkExist.value = false
        ClearChoose()
        loading.value = false
        // toast.clear()
      } else {
        if (response?.response?.data?.data[0]?.message_code === 'ERROR_UPLOAD_MAX_NUMBER') errorMaxUpload.value = true
        // 2022/09/15 TienNV fix bug uat#4114 OE80
        else if (response?.response?.data?.data[0]?.message_code === 'ERROR_UPLOAD_FILE_FORMAT') errorFileFormatUpload.value = true
        else if (response?.response?.data?.data[0]?.status === 404) error404.value = true
        else {
          checkExist.value = true
          data.value = response?.data?.data
          for (const item of response?.data?.data.invited_employee_users_fails) {
            if (item?.message_code === 'VALIDATE_DUPLICATE_UPLOAD') {
              dataUploadDub.value = item.message_code
              break
            } else if (item?.message_code?.code !== 'VALIDATE_DUPLICATE_UPLOAD') {
              dataUploadDub.value = item?.message_code?.code
              break
            }
          }
          errorMaxUpload.value = false
          errorFileFormatUpload.value = false
          error404.value = false
        }
        hiddenSubmit.value = true
        loading.value = false
      }
      setTimeout(() => {
        checkExist.value = false
      }, 500)
    } catch (error) {
      console.log(error)
      loading.value = false

      hiddenSubmit.value = true
    }
  }
}
const transitOE12 = () => {
  router.push(OE12_PATH)
}

const renderError = (code: string, field: string) => {
  switch (code) {
    case 'VALIDATE_MAIL':
      return translate('validateMail', field)
    case 'VALIDATE_MAX_STRING':
      return translate('maxString', field, field === 'email' ? [256] : [100])
    case 'VALIDATE_REQUIRE_INPUT':
      return translate('requiredInput', field)
    case 'VALIDATE_DUPLICATE':
      return translate('SA20emailSame', field)
    case 'VALIDATE_INVALID_FILE_FORMAT':
      return translate('VALIDATE_INVALID_FILE_FORMAT', field)
    case 'VALIDATE_DUPLICATE_UPLOAD':
      return translate('VALIDATE_DUPLICATE_UPLOAD', field)
    case 'VALIDATE_INVALID_CHARACTERS':
      return translate('validateEmoji', field)
    case 'VALIDATE_NG_WOLDS':
      return translate('VALIDATE_NG_WOLDS', field)
  }
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(Breadcrumb, {
      breadcrumb: breadcrumb,
      class: "mx-0"
    }),
    _createElementVNode("form", {
      class: "bg-white rounded-4 shadow p-4 mb-5",
      onSubmit: _cache[1] || (_cache[1] = _withModifiers(() => {}, ["prevent"]))
    }, [
      _createElementVNode("h5", _hoisted_1, _toDisplayString(_unref(translate)('OE80uploaded')), 1),
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("a", _hoisted_3, _toDisplayString(_unref(translate)('CsvFormat')), 1)
      ]),
      _createElementVNode("p", _hoisted_4, _toDisplayString(_unref(translate)('OE80selectOne')), 1),
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("div", _hoisted_8, [
              _createElementVNode("span", {
                onClick: handleClick,
                class: "input-group-text cursor-pointer"
              }, _toDisplayString(_unref(translate)('selectFile')), 1),
              _createElementVNode("input", {
                type: "",
                class: _normalizeClass([
                'form-control fs-7',
                !['application/vnd.ms-excel', 'text/csv'].includes(fileType.value) && fileName.value ? 'is-invalid' : '',
                !fileName.value && ClickSubmit.value && checkExist.value ? 'is-invalid' : '',
                errorFileFormatUpload.value || errorMaxUpload.value || error404.value ? 'is-invalid' : '',
                data.value?.invited_employee_users_fails?.length > 0 && data.value?.invited_employee_users_ids?.length === 0 ? 'is-invalid' : '',
                _unref(v$)?.file?.$errors[0]?.$validator === 'fileSizeValidation' ? 'is-invalid' : '',
              ]),
                id: "inputPassword",
                placeholder: _unref(translate)('notSelected'),
                value: fileName.value,
                readonly: ""
              }, null, 10, _hoisted_9),
              _createElementVNode("span", {
                onClick: ClearChoose,
                class: "input-group-text bg-white cursor-pointer"
              }, _toDisplayString(_unref(translate)('ST50cancelFile')), 1)
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_10, [
          _createElementVNode("input", {
            type: "file",
            accept: ".csv",
            placeholder: _unref(translate)('notSelected'),
            ref: (_value, _refs) => {
              _refs['inputRef'] = _value
              inputRef.value = _value
            },
            onChange: handleChangeFile,
            onClick: _cache[0] || (_cache[0] = 
            (event) => {
              event.target.value = null
            }
          )
          }, null, 40, _hoisted_11)
        ]),
        (_unref(v$)?.file?.$errors[0]?.$validator === 'fileSizeValidation')
          ? (_openBlock(), _createElementBlock("p", _hoisted_12, _toDisplayString(_unref(translate)('validateFileSize', '', [_unref(MAX_UPLOAD_FILE_SIZE_MB)])), 1))
          : _createCommentVNode("", true),
        (!['application/vnd.ms-excel', 'text/csv'].includes(fileType.value) && fileName.value)
          ? (_openBlock(), _createElementBlock("p", _hoisted_13, _toDisplayString(_unref(translate)('VALIDATE_FILE_EXTENSION')), 1))
          : _createCommentVNode("", true),
        (fileName.value === '' && ClickSubmit.value && checkExist.value)
          ? (_openBlock(), _createElementBlock("p", _hoisted_14, _toDisplayString(_unref(translate)('OE80required')), 1))
          : _createCommentVNode("", true),
        (error404.value)
          ? (_openBlock(), _createElementBlock("p", _hoisted_15, "アップロード失敗しました。"))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", _hoisted_16, [
        _createElementVNode("div", _hoisted_17, _toDisplayString(_unref(translate)('OE80noteUploadMaxNumber')), 1)
      ]),
      (data.value?.invited_employee_users_ids?.length > 0)
        ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
            _createElementVNode("div", _hoisted_19, [
              _createElementVNode("div", _hoisted_20, [
                _hoisted_21,
                _createElementVNode("div", _hoisted_22, _toDisplayString(_unref(translate)('OE80textSuccess1')), 1)
              ]),
              _createElementVNode("div", _hoisted_23, _toDisplayString(_unref(translate)('OE80text2')), 1),
              _createElementVNode("div", _hoisted_24, _toDisplayString(_unref(translate)('OE80register')) + "：" + _toDisplayString(data.value?.invited_employee_users_ids?.length) + _toDisplayString(_unref(translate)('OE80subject')), 1),
              (data.value?.invited_employee_users_fails.length > 0)
                ? (_openBlock(), _createElementBlock("div", _hoisted_25, [
                    _createElementVNode("div", _hoisted_26, _toDisplayString(_unref(translate)('OE80text2ValidateDuplicate')), 1),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(data.value?.invited_employee_users_fails, (item) => {
                      return (_openBlock(), _createElementBlock("div", { key: item }, [
                        _createElementVNode("div", _hoisted_27, [
                          _createTextVNode("・" + _toDisplayString(item.line) + _toDisplayString(_unref(translate)('OE80line')) + " ", 1),
                          _createElementVNode("div", null, _toDisplayString(item?.message_code?.code ? renderError(item?.message_code?.code, item?.message_code?.field) : renderError(item?.message_code)), 1)
                        ])
                      ]))
                    }), 128))
                  ]))
                : _createCommentVNode("", true)
            ])
          ]))
        : _createCommentVNode("", true),
      (errorMaxUpload.value || errorFileFormatUpload.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_28, [
            _createElementVNode("div", _hoisted_29, [
              _createElementVNode("div", _hoisted_30, [
                _hoisted_31,
                _createElementVNode("div", _hoisted_32, _toDisplayString(_unref(translate)('OE80text4')), 1)
              ]),
              _createElementVNode("div", _hoisted_33, _toDisplayString(_unref(translate)('OE80text2')), 1),
              _createElementVNode("span", _hoisted_34, "・" + _toDisplayString(_unref(translate)(errorMaxUpload.value ? 'ERROR_UPLOAD_MAX_NUMBER' : 'ERROR_UPLOAD_FILE_FORMAT')), 1),
              _createElementVNode("div", _hoisted_35, _toDisplayString(_unref(translate)('OE80text3')), 1)
            ])
          ]))
        : (data.value?.invited_employee_users_fails?.length > 0 && data.value.invited_employee_users_ids.length === 0 && dataUploadDub.value === 'VALIDATE_DUPLICATE')
          ? (_openBlock(), _createElementBlock("div", _hoisted_36, [
              _createElementVNode("div", _hoisted_37, [
                _createElementVNode("div", _hoisted_38, [
                  _hoisted_39,
                  _createElementVNode("div", _hoisted_40, _toDisplayString(_unref(translate)('OE80textSuccess1')), 1)
                ]),
                _createElementVNode("div", _hoisted_41, _toDisplayString(_unref(translate)('OE80text2ValidateDuplicate')), 1),
                (data.value?.invited_employee_users_fails.length > 0)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_42, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(data.value?.invited_employee_users_fails, (item) => {
                        return (_openBlock(), _createElementBlock("div", { key: item }, [
                          _createElementVNode("div", _hoisted_43, [
                            _createTextVNode("・" + _toDisplayString(item.line) + _toDisplayString(_unref(translate)('OE80line')) + " ", 1),
                            _createElementVNode("div", null, _toDisplayString(item?.message_code?.code ? renderError(item?.message_code?.code, item?.message_code?.field) : renderError(item?.message_code)), 1)
                          ])
                        ]))
                      }), 128))
                    ]))
                  : _createCommentVNode("", true),
                _createElementVNode("div", _hoisted_44, _toDisplayString(_unref(translate)('OE80register')) + "：" + _toDisplayString(data.value?.invited_employee_users_ids?.length) + _toDisplayString(_unref(translate)('OE80subject')), 1)
              ])
            ]))
          : (data.value?.invited_employee_users_fails?.length > 0 && dataUploadDub.value !== 'VALIDATE_DUPLICATE')
            ? (_openBlock(), _createElementBlock("div", _hoisted_45, [
                _createElementVNode("div", _hoisted_46, [
                  _createElementVNode("div", _hoisted_47, [
                    _hoisted_48,
                    _createElementVNode("div", _hoisted_49, _toDisplayString(_unref(translate)('OE80text4')), 1)
                  ]),
                  _createElementVNode("div", _hoisted_50, _toDisplayString(_unref(translate)('OE80text2')), 1),
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(data.value?.invited_employee_users_fails, (item) => {
                    return (_openBlock(), _createElementBlock("div", { key: item }, [
                      _createElementVNode("div", _hoisted_51, [
                        _createTextVNode("・" + _toDisplayString(item.line) + _toDisplayString(_unref(translate)('OE80line')) + " ", 1),
                        _createElementVNode("div", null, _toDisplayString(item?.message_code?.code ? renderError(item?.message_code?.code, item?.message_code?.field) : renderError(item?.message_code)), 1)
                      ])
                    ]))
                  }), 128)),
                  _createElementVNode("div", _hoisted_52, _toDisplayString(_unref(translate)('OE80text3')), 1)
                ])
              ]))
            : _createCommentVNode("", true),
      (!hiddenSubmit.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_53, [
            _createVNode(Button, {
              title: _unref(translate)('OE12button2'),
              type: 'secondary',
              className: 'fw-bold',
              onClick: SubmitCSV,
              loading: loading.value,
              disabled: disableBtn.value || loading.value
            }, null, 8, ["title", "loading", "disabled"])
          ]))
        : _createCommentVNode("", true),
      (hiddenSubmit.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_54, [
            _createVNode(Button, {
              title: _unref(translate)('back'),
              type: 'secondary',
              className: 'fw-bold',
              onClick: transitOE12
            }, null, 8, ["title"])
          ]))
        : _createCommentVNode("", true)
    ], 32)
  ], 64))
}
}

})